<template>
  <section-layout
    :disabled="!cambiado || loading"
    :loading="loading || saving"
    :showButton="false"
  >
    <template v-slot:title>
      {{ localization.tabsTitles.tiposSolicitudes }}
    </template>
    <template v-slot:content>
        <v-row align="center" dense class="mt-4">
            <v-col cols="1">
            </v-col>
            <v-col cols="2">
            </v-col>
            <v-col cols="1">
                <span>Excluir</span>
            </v-col>
        </v-row>
        <draggable
          :list="items"
          :disabled="!enabled"
          class="list-group"
          ghost-class="ghost"
          @change="update()"
        >
          <v-row v-for="(item,i) in items" :key="i" dense align="center" :class="i == 0 ? '' : 'mt-2'">
            <v-col cols="1">
                <v-icon size="32" color="primary">mdi mdi-swap-vertical</v-icon>
            </v-col>
            <v-col cols="2">
                <span class="text">{{ item.descripcion }}</span>
            </v-col>
            <v-col cols="1">
                <v-checkbox
                    v-model="item.excluida"
                    :id="item.id"
                    color="primary"
                    hide-details
                    @change="update()"
                />
            </v-col>
        </v-row>
        </draggable>
    </template>
  </section-layout>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";

export default {
  name: "simple",
  display: "Simple",
  order: 0,
  components: {
    draggable
  },
  props: {
    saving: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    cambiado: {
      type: Boolean,
      default: false
    },
    configuracion: {
      type: Object,
      default: () => ({})
    }
  },
  mounted() {
    this.obtenerEstructuraDescargaDocumentos()
  },
  data() {
    return {
      enabled: true,
      itemsDefault: [
        { id: "1", codigo: "promocion", descripcion: "Promocion", orden: 1, name: "Promocion", excluida: false},
        { id: "2", codigo: "inmueble", descripcion: "Inmueble", orden: 2, name: "Inmueble", excluida: false },
        { id: "3", codigo: "visita", descripcion: "Visita", orden: 3, name: "Visita", excluida: false },
        { id: "4", codigo: "incidencia", descripcion: "Incidencia", orden: 4, name: "Incidencia", excluida: false },
        { id: "5", codigo: "tipoDocumento", descripcion: "TipoDocumento", orden: 5, name: "Tipo documento", excluida: false },
        { id: "6", codigo: "oficio",  descripcion: "Oficio", orden: 6, name: "Oficio", excluida: true },
      ],
      dragging: false,
      excluida: false
    };
  },
  computed: {
    localization () {
      return this.$t('sectionConfiguracion')
    },
    items(){
        let itemsAux = this.$store.state.configuracion.estructuraDescargaDocumentos
        if ( itemsAux &&  itemsAux.length > 0)
            return itemsAux
        else
            return this.itemsDefault
    }
  },
  methods: {
    ...mapActions({
        obtenerEstructuraDescargaDocumentos: 'configuracion/obtenerEstructuraDescargaDocumentos'
    }),
    update () {
      this.configuracion.estructuraDescargaDocumentos = this.items
      this.$emit('cambiado', true)
    }
  }
};
</script>

<style scoped>
.iconSize {
  width: 16px !important;
}
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
